import React, { Dispatch, SetStateAction } from "react"
import { AxiosRequestConfig, AxiosResponse } from "axios"
import { useState } from "react"
import * as endpoint from "./endpoint.js"
import { httpRequest } from "./http-request.js"

export const httpGet = <T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> => {
  return httpRequest.get(endpoint.withRoot(url), config)
}

export const httpPost = <TResponse>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<TResponse>> => {
  return httpRequest.post(endpoint.withRoot(url), data, config)
}

export const httpPut = <TResponse>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<TResponse>> => {
  return httpRequest.put(endpoint.withRoot(url), data, config)
}

export const httpPatch = <TResponse>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<TResponse>> => {
  return httpRequest.patch(endpoint.withRoot(url), data, config)
}

export const httpDelete = <TResponse>(url: string, config?: AxiosRequestConfig, data?: any): Promise<AxiosResponse<TResponse>> => {
  return httpRequest.delete(endpoint.withRoot(url), config)
}

type HttpTriggerFunc<TRequest> = (request: TRequest) => void

interface HookReturn<TRequest, TResponse, Data=TResponse | undefined> {
  trigger: HttpTriggerFunc<TRequest>;
  isLoading: boolean;
}
interface HookParams<TRequest, TResponse> {
  func: (request: TRequest) => Promise<AxiosResponse<TResponse>>;
  setState: Dispatch<SetStateAction<TResponse | undefined>>;
  transform?: (data: TResponse) => TResponse;
}
export const useHttpData = <TRequest, TResponse>(params: HookParams<TRequest, TResponse>): HookReturn<TRequest, TResponse> => {

  const [isLoading, setLoading] = useState<boolean>(false)

  const { setState } = params

  const trigger = (request: TRequest) => {
    setLoading(true)
    params.func(request)
      .then((response) => {
        if (params.transform) {
          setState(params.transform(response.data))
        } else {
          setState(response.data)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return { trigger, isLoading }
}

// request<T = any, R = axios.AxiosResponse<T>, D = any>(config: axios.AxiosRequestConfig<D>): Promise<R>;
// delete<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, config?: axios.AxiosRequestConfig<D>): Promise<R>;
// head<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, config?: axios.AxiosRequestConfig<D>): Promise<R>;
// options<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, config?: axios.AxiosRequestConfig<D>): Promise<R>;
// post<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, data?: D, config?: axios.AxiosRequestConfig<D>): Promise<R>;
// put<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, data?: D, config?: axios.AxiosRequestConfig<D>): Promise<R>;
// patch<T = any, R = axios.AxiosResponse<T>, D = any>(url: string, data?: D, config?: axios.AxiosRequestConfig<D>): Promise<R>;
